// extracted by mini-css-extract-plugin
export default {"textarea":"TextArea_textarea__UuJEZ","textarea--resizable":"TextArea_textarea--resizable__8sgx2"};